import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { Box, TableCell, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

const fadeOut = keyframes`
    from {
        opacity: 1
    }
    to {
        opacity: 0
    }
`

export const FunderSharedGoalsContainer = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin-bottom: 100px;
  padding: 20px;
  min-height: 90vh;
`

export const Header = styled(Typography)`
  ${typography.up2.semiBoldSans}
`

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Text = styled(Typography)`
  min-width: 120px;
  ${typography.baseline.regularSans}
`

export const ErrorMessage = styled(Text)`
  animation: ${fadeOut} 4s ease-in-out forwards;
  animation-delay: 6s;
  color: ${colors.feedback.errorDark};
  opacity: 1;
`

export const SuccessMessage = styled(Text)`
  animation: ${fadeOut} 4s ease-in-out forwards;
  animation-delay: 6s;
  color: ${colors.feedback.successDark};
  opacity: 1;
`

export const SelectContainer = styled(Box)`
  display: flex;
  max-width: 200px;
  height: 56px;
`

export const TextFieldContainer = styled(Box)`
  display: flex;
`

export const Row = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 20px;
  height: 56px;
`

export const Cell = styled(TableCell)`
  text-wrap: nowrap;
`
